"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _StartAdornmentWrapper = _interopRequireDefault(require("./StartAdornmentWrapper"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var StartAdornment = function StartAdornment(_ref) {
  var adornment = _ref.adornment,
    disabled = _ref.disabled;
  if (adornment) {
    var isTextAdornment = adornment && typeof adornment === 'string';
    return /*#__PURE__*/_react["default"].createElement(_StartAdornmentWrapper["default"], {
      disabled: disabled,
      isText: isTextAdornment
    }, adornment);
  }
  return null;
};
StartAdornment.propTypes = process.env.NODE_ENV !== "production" ? {
  adornment: _propTypes["default"].element,
  disabled: _propTypes["default"].bool
} : {};
var _default = exports["default"] = StartAdornment;